$(function () {

    $('.enter__form .btn').on('click', function (e) {
        e.preventDefault();

        var $this = $('.enter__form');
        $this.find('.input-block').each(function () {

            var inpBl = $(this);
            var inp = $(this).find('input').val().length;
            if (inp > 2) {
                inpBl.removeClass('wrong');
            } else {
                inpBl.addClass('wrong');
            }

            // $('.error_message').addClass('error_message_visible');
        });

        if ($this.find('.wrong').length == 0) {

            //

            $this[0].submit();
        }

    });

    $('input, textarea').on('focusout', function (e) {

        if ($(this).val().length > 0) {
            $(this).parent().addClass('noempty');
        } else {
            $(this).parent().removeClass('noempty');
        }
    });

    if ($('main').hasClass('enter')) {
        // Проверка на предзаполнение полей
        $(window).on('load', function () {
            setTimeout(function () {

                $('.enter__form .input-block input').each(function () {
                    if ($(this).val().length > 0) {
                        $(this).parent().addClass('noempty');
                        console.log($(this).val());
                    }
                });
            }, 150);

            setTimeout(function () {
                $('.enter__form .input-block').removeAttr('style');
                $('.enter__form .input-block input').removeAttr('style');
                $('.enter__form .input-block .label').removeAttr('style');
            }, 300);

        })
    }

    // Видеть\ не видеть пароль
    $('.passwordVisible').on('click', function(e) {
        e.preventDefault();
        let $this = $(this),
            passInput = $this.siblings('input');

        if ($this.hasClass('passwordVisible_true')) {
            $this.removeClass('passwordVisible_true');
            passInput.attr('type', 'password')
        } else {
            $this.addClass('passwordVisible_true');
            passInput.attr('type', 'text')
        }
    })


});
